// Which rows belong to a channel that left the overlay. The feed keeps rows it
// already showed until they scroll away, so a channel taken out of the overlay
// (or a builder preview switched to another overlay's channels) would otherwise
// stay on screen, and on a quiet chat that is for good.

/** One channel as its rows name it: logins and slugs are case-blind. */
export const channelRowKey = (provider: string, channel: string): string => `${provider}:${channel.toLowerCase()}`;

/** The channels in `before` that `now` no longer has. */
export function goneChannels(before: ReadonlySet<string>, now: ReadonlySet<string>): Set<string> {
  return new Set([...before].filter((k) => !now.has(k)));
}

/** Whether a row came from one of `gone`. A row with no channel is kept. */
export function isFromGoneChannel(row: { provider?: string; channel?: string }, gone: ReadonlySet<string>): boolean {
  return !!row.channel && gone.has(channelRowKey(row.provider ?? 'twitch', row.channel));
}
